module.exports = new __parcel__URL__("pvp_defend_button.76ae9ff6.png").toString();